import {
    TAB,
    SET_IPFROM
} from '../types'

let state = {
    tab: 0,
    isChina: false,
}

const mutations = {
    [TAB](state, tab) {
        state.tab = tab;
    },
    [SET_IPFROM](state, data) {
        state.isChina = data;
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js